import { render, staticRenderFns } from "./StaffMagList.vue?vue&type=template&id=cb2cc796&"
import script from "./StaffMagList.vue?vue&type=script&lang=js&"
export * from "./StaffMagList.vue?vue&type=script&lang=js&"
import style0 from "./StaffMagList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports